import React from 'react';

import FieldRadioGroup from '@magoosh/lib/formik_inputs/field_radio_group';

import { ApplicationCycleFilterConfig } from '@admissions/types';

interface Props {
  filterConfig: ApplicationCycleFilterConfig;
  value: string;
}

// For use within a Formik form
const RadioFilter: React.FC<Props> = (props) => {
  return (
    <FieldRadioGroup
      name={props.filterConfig.key}
      value={props.value}
      optionsArray={
        props.filterConfig.options.map((option) => (
          {
            label: option.name,
            value: option.value
          }
        ))
      }
    />
  );
};

export default RadioFilter;
